import { alpha } from '@mui/material/styles';
import { ChartColorGroupPalette } from './types';

interface ChartColorGroupShades {
  fillDark2: string;
  fillDark1: string;
  fill: string;
  fillLight1: string;
  fillLight2: string;
}

export const createChartColorGroupPaletteFactory = (semiOpacity: number, tonalOpacity: number) =>
  (shades: ChartColorGroupShades): ChartColorGroupPalette => ({
    ...shades,
    fillSemi: alpha(shades.fill, semiOpacity),
    tonalBackground: alpha(shades.fill, tonalOpacity),
  });
